<template>
  <!--  党建工作-->
  <div>
    <!-- 顶部banner图 + 面包屑 -->
    <div style="width: 100%; height: 500px">
      <div id="banner1">
        <BannerSwiper msg="健康苗医"></BannerSwiper>
      </div>
    </div>
    <div style="position: relative; top: 10px; left: 0px" id="administrative">
      <breadcrumb msg="健康苗医" id="breadcrumb"></breadcrumb>
    </div>
    <div id="swiper">
      <h1 style="font-family: dasongbiao; color: rgb(69, 109, 171)">
        健康苗医
      </h1>
      <div id="swiperBar">
        <div id="left"></div>
        <div class="swiper-container swiper3">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in list"
              :key="index"
              @click="toSelect(item, index)"
            >
              <div v-if="id === item.id" id="swiperBodyName2">
                {{ item.name }}
              </div>
              <div v-else id="swiperBodyName">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div id="right"></div>
      </div>
      <newsList v-if="indexKey == 1" :data="newList"></newsList>
      <productList v-if="indexKey == 0" :data="newList"></productList>
      <div style="text-align: center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="filter.page"
          :page-size="filter.limit"
          background
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import BannerSwiper from "../components/bannerSwiper";
import Swiper from "swiper";
import "../../node_modules/swiper/css/swiper.css";
import breadcrumb from "../components/breadcrumb";
import newsList from "../components/news";
import productList from "../components/product";
import { articlePage, drugInfo } from "../../api/api.js";

export default {
  components: { breadcrumb, newsList, BannerSwiper, productList },
  data() {
    return {
      id: "",
      indexKey: "",
      sectionList: JSON.parse(sessionStorage.getItem("sectionList")),
      filter: {
        keyword: "",
        status: "",
        page: 1,
        limit: 12,
        sort: "DESC",
        orderField: "pubdate",
        status: "0",
      },
      list: [],
      newList: [],
      total: 0,
    };
  },
  mounted() {
    var mySwiper = new Swiper(".swiper3", {
      slidesPerView: 2,
      centeredSlides: true,
      centeredSlidesBounds: true,
    });
  },
  created() {
    for (let i = 0; i < this.sectionList.length; i++) {
      if ("/" + this.sectionList[i].url === this.$route.path) {
        this.list = this.sectionList[i].children;
      }
    }
    this.id = this.list[0].id;
    // this.getNewList();
    this.getDrugInfo();
  },
  methods: {
    toSelect(data, index) {
      this.id = data.id;
      this.indexKey = index;
      if (index == 0) {
        this.getDrugInfo();
      } else {
        this.getNewList();
      }
    },
    getDrugInfo() {
      this.filter.sectionId = this.id;
      drugInfo(this.filter).then((res) => {
        if (res.data.code === 200) {
          this.newList = res.data.data;
          console.log(this.newList);
          this.total = res.data.total;
        }
      });
    },
    getNewList() {
      this.filter.sectionId = this.id;
      articlePage(this.filter).then((res) => {
        if (res.data.code === 200) {
          this.newList = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      if (this.indexKey == 0) {
        this.getDrugInfo();
      } else {
        this.getNewList();
      }
    },
  },
};
</script>
<style lang="less" scoped>
#banner1 {
  height: 500px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

#swiper {
  padding-top: 30px;
  background-image: url(../assets/img/jkjt3.jpg);

  h1 {
    text-align: center;
    color: #595959;
  }
}

#swiperBodyName {
  width: 80%;
  height: 80%;
  margin: 5px auto;
  line-height: 40px;
  background-image: url(../assets/img/pubc-tabs-icon3.png);
  background-size: 100% 100%;
}

#swiperBodyName2 {
  width: 80%;
  height: 80%;
  margin: 5px auto;
  line-height: 40px;
  background-image: url(../assets/img/pubc-tabs-icon4.png);
  background-size: 100% 100%;
  color: white;
}

#swiperBar {
  width: 550px;
  height: 50px;
  display: flex;
  color: #595959;
  font-weight: 600;
  margin: 0 auto;
  flex-direction: row;

  #left {
    background-image: url(../assets/img/pubc-tabs-icon1.png);
    background-size: 100% 100%;
    width: 30px;
  }

  .swiper-container {
    width: 1000px;
    text-align: center;
    float: left;
  }

  #right {
    background-image: url(../assets/img/pubc-tabs-icon2.png);
    background-size: 100% 100%;
    width: 30px;
  }
}
</style>
